import React from 'react'
import ReactDOM from 'react-dom'

import template from './template.html'
import Controller from './controller'

import ToolboxTextSettings from '~/reactapp/Settings/ToolboxTextSettings'
import CustomEmbedSettingsModal from '~/reactapp/Settings/CustomEmbedSettingsModal'
import AnnotationModal from '~/reactapp/Settings/AnnotationsModal'

import { OpenBetaToggle } from './components/OpenBetaToggle'
import { HyperlinkConfig } from './components/HyperlinkConfig/HyperlinkConfig'

function reactRenderFactory(angularScope, rootElement, Component) {
  angularScope.$on('$destroy', () =>
    ReactDOM.unmountComponentAtNode(rootElement)
  )
  return (props) => {
    ReactDOM.render(props.visible && <Component {...props} />, rootElement)
  }
}

function Link(scope, el) {
  const rootElement = el.find('#toolboxContentElementSettingsModal')[0]
  const openBetaToggleElement = document.getElementById('openBetaToggle')
  const hyperlinkConfigElement = document.getElementById(
    'composer-settings--hyperlink-config'
  )

  scope.renderTextSettingsModal = reactRenderFactory(
    scope,
    rootElement,
    ToolboxTextSettings
  )
  scope.renderCustomEmbedSettingsModal = reactRenderFactory(
    scope,
    rootElement,
    CustomEmbedSettingsModal
  )
  scope.renderCreateUpdateAnnotationModal = reactRenderFactory(
    scope,
    rootElement,
    AnnotationModal
  )
  scope.renderOpenBetaToggle = reactRenderFactory(
    scope,
    openBetaToggleElement,
    OpenBetaToggle
  )
  scope.renderHyperlinkConfig = reactRenderFactory(
    scope,
    hyperlinkConfigElement,
    HyperlinkConfig
  )
}

function directive($rootScope) {
  return {
    restrict: 'AE',
    replace: false,
    template,
    controller: Controller,
    link: Link,
  }
}

export default ['$rootScope', directive]
